import { fetchDurationBegin, fetchDurationFailure, fetchDurationSuccess } from './types';
import { fetchDuration } from '../api/Duration';

export const getDuration = (id, amount) => (dispatch) => {
  dispatch(fetchDurationBegin());
  return fetchDuration(id, amount)
    .then((data) => dispatch(fetchDurationSuccess(data)))
    .catch((error) => dispatch(fetchDurationFailure(error)));
};
